export default () =>
  import(/* webpackChunkName: 'coffee/app/agreement/payment' */ './Payment');
